import { __assign, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import AnalyticsContext from '../components/AnalyticsContext';
var withAnalyticsContext = function (defaultData) { return function (WrappedComponent) {
    var WithAnalyticsContext = forwardRef(function (_a, ref) {
        var analyticsContext = _a.analyticsContext, rest = __rest(_a, ["analyticsContext"]);
        var analyticsData = useMemo(function () { return (__assign(__assign({}, defaultData), analyticsContext)); }, [analyticsContext]);
        return (React.createElement(AnalyticsContext, { data: analyticsData },
            React.createElement(WrappedComponent, __assign({}, rest, { ref: ref }))));
    });
    // @ts-ignore
    WithAnalyticsContext.displayName = "WithAnalyticsContext(" + (
    // @ts-ignore disneyName doesn't exist on type
    WrappedComponent.displayName || WrappedComponent.name) + ")";
    return WithAnalyticsContext;
}; };
export default withAnalyticsContext;
//# sourceMappingURL=withAnalyticsContext.js.map